<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn('text-xs font-medium leading-normal not-first:mt-0.5', props.class)">
    <slot />
  </div>
</template>
